import { useState, useCallback } from 'react';
import useAttributesAllergensApi from './useAttributesAllergensApi';
import { AttributeConflict } from '../types';

const useConflicts = () => {
  const { getConflicts } = useAttributesAllergensApi();
  const [conflicts, setConflicts] = useState<AttributeConflict[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadConflicts = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      setConflicts(await getConflicts());
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load conflicts');
      setConflicts([]);
    } finally {
      setIsLoading(false);
    }
  }, [getConflicts]);

  return { conflicts, isLoading, error, loadConflicts };
};

export default useConflicts;
